<template>
  <el-dialog :title="sizeForm.id?'编辑模板消息':'添加模板消息'" :visible.sync="dialogVisible" v-if="dialogVisible"
             :width="width" top="6vh" modal-append-to-body
             :close-on-click-modal="false"
             :close-on-press-escape="false"
             :append-to-body="true" custom-class="beautiful-dialog">
    <el-form ref="dataForm" :rules="rules" :model="sizeForm" label-width="100px" size="small" class="beautiful-form">
      <!-- 模板类型/模板状态 -->
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="模板类型" prop="templateType">
            <el-select v-model="sizeForm.templateType" :disabled="addOrUpdateCheck" placeholder="请选择模板类型" class="beautiful-select" clearable>
              <el-option v-for="item in dictTypeMap.message_center_template_type" :key="item.id" :label="item.name" :value="item.id.toString()"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="模板状态" prop="status">
            <el-select v-model="sizeForm.status" placeholder="请选择模板状态" class="beautiful-select" clearable>
              <el-option v-for="item in dictTypeMap.tmsStatus" :key="item.id" :label="item.name" :value="item.id.toString()"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <!-- 标题 -->
      <el-row>
        <el-form-item label="模板标题" prop="title">
          <el-input v-model="sizeForm.title" placeholder="请输入模板标题" class="beautiful-input"></el-input>
        </el-form-item>
      </el-row>

      <!-- 短语 -->
      <el-row>
        <el-form-item label="短语" prop="phrase">
          <el-input v-model="sizeForm.phrase" type="textarea" :rows="3" placeholder="请输入短语，例如：订单通知、物流提醒等" class="beautiful-textarea"></el-input>
        </el-form-item>
      </el-row>

      <!-- 提醒时间 -->
      <el-row v-if="sizeForm.templateType && sizeForm.templateType == 'ORDER_INFO'">
        <el-form-item label="提醒时间">
          <el-input v-model="sizeForm.extendedJson.time"
                    size="small"
                    type="number"
                    max="9999999" min="1"
                    onkeypress='return( /[\d]/.test(String.fromCharCode(event.keyCode)))'
                    onchange="if(value){value=value.replace(/[^\d]/g,1);if(Number(value)<=1){value=1}} if(Number(value)>9999999){value=9999999}"
                    oninput="if(value){value=value.replace(/[^\d]/g,1);if(Number(value)<=1){value=1}} if(Number(value)>9999999){value=9999999}">
            <template slot="append">分</template>
          </el-input>
        </el-form-item>
      </el-row>

      <!-- 占位符提示 -->
      <el-row v-if="sizeForm.templateType && currentPlaceholders.length">
        <el-form-item label="可用占位符" prop="phrase">
          <div class="placeholder-wrapper">
            <div class="placeholder-tags">
              <div
                  v-for="item in currentPlaceholders"
                  :key="item.key"
                  class="placeholder-tag"
                  @click="copy(item.key)"
              >
                <span class="tag-key">{{ item.key }}</span>
                <span class="tag-desc">{{ item.desc }}</span>
                <i class="el-icon-document-copy"></i>
              </div>
            </div>
          </div>
        </el-form-item>
      </el-row>

      <!-- 模板内容 -->
      <el-row>
        <el-form-item label="模板内容" prop="content" class="content-form-item">
          <div class="editor-wrapper">
            <tipTap ref="tipTapRef" v-model="sizeForm.content" :editable="true"/>
          </div>
        </el-form-item>
      </el-row>
    </el-form>

    <span slot="footer" class="dialog-footer">
      <el-button class="cancel-btn" size="medium" @click="handleCancel">取消</el-button>
      <el-button class="confirm-btn" size="medium" :loading="btnLoading" type="primary" @click="handleConfirm">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import Tinymce from '@/components/Tinymce'
import * as myJsonClone from "@/utils/myJsonClone"
import tipTap from '@/components/el-tiptap'

export default {
  components: {Tinymce, tipTap},
  props: {
    width: {
      type: String,
      default: '900px'
    }
  },
  data() {
    return {
      addOrUpdateCheck: false,
      dialogVisible: false,
      btnLoading: false,
      sizeForm: {
        content: '',
        extendedJson: {
          time: null
        }
      },
      rules: {
        title: [
          {required: true, message: '请输入模板标题', trigger: 'blur'}
        ],
        templateType: [
          {required: true, message: '请选择模板类型', trigger: 'change'}
        ],
        status: [
          {required: true, message: '请选择模板状态', trigger: 'change'}
        ],
        phrase: [
          {required: true, message: '请输入模板短语', trigger: 'blur'}
        ],
        content: [
          {required: true, message: '请输入模板内容', trigger: 'blur'}
        ],
      },
      // 占位符配置映射 - 根据模板类型ID配置对应的占位符
      placeholderConfig: {
        // 年审提醒
        'VEHICLE_INSPECT': [
          { key: '${name}', desc: '车队·车牌号' },
          { key: '${type}', desc: '年审类型[行驶证,综合等]' },
          { key: '${time}', desc: '过期时间' }
        ],
        // 保险提醒
        'BASE_INSURE': [
          { key: '${name}', desc: '车队·车牌号' },
          { key: '${type}', desc: '保险类型[商业险,交强险等]' },
          { key: '${time}', desc: '过期时间' }
        ],
        // 提货到场提醒
        'ORDER_INFO': [
          { key: '${name}', desc: '订单号' },
          { key: '${startRoute}', desc: '提货地址' },
          { key: '${endRoute}', desc: '卸货地址' },
          { key: '${time}', desc: '提货时间' }
        ]
      },
    }
  },
  computed: {
    dictTypeMap() {
      return this.$store.state.common.dictTypeMap
    },
    currentPlaceholders() {
      const type = this.sizeForm.templateType
      if (!type) return []
      return this.placeholderConfig[type] || []
    }
  },
  methods: {
    openDialog(row) {
      this.addOrUpdateCheck = false
      this.btnLoading = false
      this.sizeForm = this.$options.data().sizeForm
      this.addOrUpdateCheck = false
      if (row && row.id) {
        this.addOrUpdateCheck = true
        let cloneRow = myJsonClone.getClone(row)
        let extendedDB = cloneRow.extended;
        delete cloneRow.extended
        let sizeFormV = cloneRow
        sizeFormV.content = this.formatRichText(cloneRow.content || null)

        // 扩展信息
        let parseExtendedDB = JSON.parse(extendedDB ? extendedDB : {});
        let extendedJsonV = {
          time: parseExtendedDB.time ? parseExtendedDB.time : null,
        }
        sizeFormV.extendedJson = extendedJsonV
        this.sizeForm = sizeFormV
      }
      this.$nextTick(() => {
        this.$forceUpdate()

        this.dialogVisible = true
      })
    },
    handleCancel() {
      this.$emit('cancel')
      this.dialogVisible = false
    },
    formatRichText(html) {
      if (!html) return ''
      let newContent = html.replace(/<img[^>]*>/gi, function (match, capture) {
        match = match.replace(/style="[^"]+"/gi, '').replace(/style='[^']+'/gi, '')
        match = match.replace(/width="[^"]+"/gi, '').replace(/width='[^']+'/gi, '')
        match = match.replace(/height="[^"]+"/gi, '').replace(/height='[^']+'/gi, '')
        return match
      })
      newContent = newContent.replace(/style="[^"]+"/gi, function (match, capture) {
        match = match.replace(/width:[^;]+;/gi, 'max-width:100%;').replace(/max-max-width:[^;]+;/gi, 'max-width:100%;')
        return match
      })
      newContent = newContent.replace(/<br[^>]*\/>/gi, '')
      newContent = newContent.replace(
          /\<img/gi,
          '<img style="max-width:100%;height:auto;display:block;margin-top:0;margin-bottom:0;"'
      )
      return newContent
    },
    copy(placeholder) {
      navigator.clipboard.writeText(placeholder);
      this.$message.success(`复制成功 ${placeholder}`)
    },
    handleConfirm() {
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          let cloneSizeForm = myJsonClone.getClone(this.sizeForm);
          this.btnLoading = true
          this.$http({
            url: this.$http.adornUrl(cloneSizeForm.id ? '/message_center/template/update' : '/message_center/template/add'),
            method: cloneSizeForm.id ? 'post' : 'put',
            data: this.$http.adornParams({
              ...cloneSizeForm,
              content: this.formatRichText(cloneSizeForm.content),
              extended: cloneSizeForm.extendedJson ? JSON.stringify(cloneSizeForm.extendedJson) : {},
            })
          }).then((response) => {
            this.$message.success('操作成功')
            setTimeout(() => {
              this.btnLoading = false
              this.handleCancel()
            }, 500)
          }).catch(() => {
            this.btnLoading = false
          })
        }
      })
    },
  }
}
</script>

<style scoped lang="less">
// 整体对话框样式
::v-deep .beautiful-dialog {
  border-radius: 12px;
  overflow: hidden;

  .el-dialog__header {
    background: #45c2b5;
    padding: 20px 24px;
    margin: 0;

    .el-dialog__title {
      color: #fff;
      font-size: 18px;
      font-weight: 500;
    }

    .el-dialog__headerbtn {
      top: 20px;

      .el-dialog__close {
        color: #fff;
        font-size: 18px;

        &:hover {
          color: #f0f0f0;
        }
      }
    }
  }

  .el-dialog__body {
    padding: 24px !important;
    background: #f8f9fa;
  }

  .el-dialog__footer {
    background: #fff;
    padding: 16px 24px;
    border-top: 1px solid #e9ecef;
  }
}

// 表单整体样式
.beautiful-form {
  ::v-deep .el-form-item {
    margin-bottom: 20px;

    .el-form-item__label {
      font-weight: 500;
      color: #2c3e50;
      font-size: 13px;

      &::before {
        color: #f56c6c;
      }
    }
  }

  // 输入框样式
  .beautiful-input {
    ::v-deep .el-input__inner {
      border-radius: 8px;
      border: 1px solid #e2e8f0;
      transition: all 0.3s ease;
      height: 38px;
      line-height: 38px;

      &:hover {
        border-color: #a0aec0;
      }

      &:focus {
        border-color: #667eea;
        box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
      }
    }
  }

  // 选择器样式
  .beautiful-select {
    width: 100%;

    ::v-deep .el-input__inner {
      border-radius: 8px;
      border: 1px solid #e2e8f0;
      transition: all 0.3s ease;
      height: 38px;
      line-height: 38px;

      &:hover {
        border-color: #a0aec0;
      }
    }

    ::v-deep .el-select__caret {
      line-height: 38px;
    }
  }

  // 文本域样式
  .beautiful-textarea {
    ::v-deep .el-textarea__inner {
      border-radius: 8px;
      border: 1px solid #e2e8f0;
      transition: all 0.3s ease;
      font-family: inherit;

      &:hover {
        border-color: #a0aec0;
      }

      &:focus {
        border-color: #667eea;
        box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
      }
    }
  }

  // 内容编辑器包装器
  .content-form-item {
    margin-bottom: 0;

    ::v-deep .el-form-item__label {
      margin-bottom: 8px;
    }
  }

  .editor-wrapper {
    background: #fff;
    border-radius: 8px;
    overflow: hidden;
    border: 1px solid #e2e8f0;
    transition: all 0.3s ease;

    &:hover {
      border-color: #a0aec0;
    }

    &:focus-within {
      border-color: #667eea;
      box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
    }
  }
}

// 占位符区域样式
.placeholder-wrapper {
  background: linear-gradient(135deg, #fff9e6 0%, #fff5d9 100%);
  border-left: 3px solid #ff9800;
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 24px;
  transition: all 0.3s ease;

  &:hover {
    box-shadow: 0 2px 8px rgba(255, 152, 0, 0.15);
  }

  .placeholder-title {
    display: flex;
    align-items: center;
    margin-bottom: 12px;
    padding-bottom: 8px;
    border-bottom: 1px solid #ffe0b2;

    i {
      font-size: 16px;
      color: #ff9800;
      margin-right: 8px;
    }

    span {
      font-size: 14px;
      font-weight: 500;
      color: #e65100;

      &.placeholder-tip {
        margin-left: auto;
        font-size: 12px;
        font-weight: normal;
        color: #ff9800;
        background: #fff3e0;
        padding: 2px 8px;
        border-radius: 12px;
      }
    }
  }

  .placeholder-tags {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;

    .placeholder-tag {
      display: inline-flex;
      align-items: center;
      gap: 8px;
      background: #fff;
      border: 1px solid #ffe0b2;
      border-radius: 6px;
      padding: 6px 12px;
      cursor: pointer;
      transition: all 0.3s ease;

      &:hover {
        background: #ff9800;
        border-color: #ff9800;
        transform: translateY(-2px);
        box-shadow: 0 4px 12px rgba(255, 152, 0, 0.3);

        .tag-key {
          color: #fff;
          background: rgba(255, 255, 255, 0.2);
        }

        .tag-desc {
          color: #fff;
        }

        i {
          color: #fff;
        }
      }

      .tag-key {
        font-family: monospace;
        font-size: 12px;
        font-weight: 600;
        color: #ff9800;
        background: #fff3e0;
        padding: 2px 6px;
        border-radius: 4px;
        transition: all 0.3s ease;
      }

      .tag-desc {
        font-size: 12px;
        color: #666;
        transition: all 0.3s ease;
      }

      i {
        font-size: 12px;
        color: #ff9800;
        opacity: 0.7;
        transition: all 0.3s ease;
      }
    }
  }
}

// 底部按钮样式
.dialog-footer {
  display: flex;
  justify-content: flex-end;
  gap: 12px;

  .cancel-btn {
    border-radius: 8px;
    padding: 9px 20px;
    border: 1px solid #e2e8f0;
    background: #fff;
    transition: all 0.3s ease;

    &:hover {
      background: #f8f9fa;
      border-color: #cbd5e0;
    }
  }

  .confirm-btn {
    border-radius: 8px;
    padding: 9px 20px;
    background: #45c2b5;
    border: none;
    transition: all 0.3s ease;

    &:hover {
      transform: translateY(-1px);
      box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);
    }

    &:active {
      transform: translateY(0);
    }
  }
}

// 响应式调整
@media (max-width: 768px) {
  ::v-deep .beautiful-dialog {
    width: 95% !important;
  }
}
</style>
